<div class="top-nav-bar">
    <top-navbar-left class="top-left-nav-bar"></top-navbar-left>
    <top-navbar-center class="top-center-nav-bar" *ngIf="!isAdminScreen"></top-navbar-center>
    <top-navbar-right class="top-right-nav-bar"></top-navbar-right>
</div>
